import { useOverlays } from "contexts/OverlayContext";
import { ReassignAccountRoleModal } from "./ReassignAccountRoleModal";

export const ReassignAccountRoleModalWrapper = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo<"reassignAccountRole">(
        "reassignAccountRole",
    );

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <ReassignAccountRoleModal
            show={!overlayIsClosing}
            onHide={closeOverlay}
            account={overlayInfo.data.account}
        />
    );
};
